import React from "react";
import placeHolderImage from "./../../images/user-image-placeholder.png";
import { getStringAbbrivation } from "../../Helper/string.helper";
import { Typography } from "@mui/material";
import { generateColorFromString } from "../../Helper/colors.helper";
import { Colors } from "../../Constants/colors";

export enum AvatarSize {
  xm = "xm",
  sm = "sm",
  md = "md",
  lg = "lg",
}
interface Props {
  image: string;
  size?: AvatarSize;
  userName?: string;
}

const getAvatarSize = (size: AvatarSize) => {
  switch (size) {
    case AvatarSize.xm:
      return "35px";
    case AvatarSize.sm:
      return "50px";
    case AvatarSize.md:
      return "75px";
    case AvatarSize.lg:
      return "100px";
    default:
      return "75px";
  }
};

const getFontSize = (size: AvatarSize) => {
  switch (size) {
    case AvatarSize.xm:
      return "12px";
    case AvatarSize.sm:
      return "16px";
    case AvatarSize.md:
      return "26px";
    case AvatarSize.lg:
      return "34px";
    default:
      return "20px";
  }
};

export const UserAvatar = ({
  image,
  size = AvatarSize.md,
  userName = "",
}: Props) => {
  const userNameAbbrivation = getStringAbbrivation(userName);

  return (
    <div
      style={{
        height: getAvatarSize(size),
        width: getAvatarSize(size),
        borderRadius: "50%",
      }}
    >
      {!image && userName ? (
        <div
          style={{
            borderRadius: "50%",
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: generateColorFromString(userName),
          }}
        >
          <Typography
            style={{
              fontSize: getFontSize(size),
              fontWeight: "bolder",
              color: Colors.White,
            }}
          >
            {userNameAbbrivation}
          </Typography>
        </div>
      ) : (
        <img
          src={image || placeHolderImage}
          alt={"Avatar"}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  );
};
